var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpsss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-112.64 -112.64 737.28 737.28",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M459.8,259.267c-4.267-76.8-71.68-132.267-145.067-131.413 c60.587,10.24,115.2,61.44,119.467,131.413c0,2.56,0,5.973,0,8.533v162.133h25.6V267.8C459.8,265.24,459.8,261.827,459.8,259.267"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070c0e"
    },
    d: "M485.4,387.267L485.4,387.267c-9.387,0-17.067-7.68-17.067-17.067V267.8 c0-9.387,7.68-17.067,17.067-17.067s17.067,7.68,17.067,17.067v102.4C502.467,379.587,494.787,387.267,485.4,387.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070c0e"
    },
    d: "M468.333,284.867h34.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070c0e"
    },
    d: "M468.333,319h34.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070c0e"
    },
    d: "M468.333,353.133h34.133"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M451.267,481.133H33.133c-14.507,0-25.6-11.093-25.6-25.6s11.093-25.6,25.6-25.6h418.133 c14.507,0,25.6,11.093,25.6,25.6S465.773,481.133,451.267,481.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2"
    },
    d: "M476.867,429.933h-25.6c14.507,0,25.6,11.093,25.6,25.6s-11.093,25.6-25.6,25.6h25.6 c14.507,0,25.6-11.093,25.6-25.6S491.373,429.933,476.867,429.933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M33.133,481.133h25.6c-14.507,0-25.6-11.093-25.6-25.6s11.093-25.6,25.6-25.6h-25.6 c-14.507,0-25.6,11.093-25.6,25.6S18.627,481.133,33.133,481.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070c0e"
    },
    d: "M289.133,80.067h34.133v-51.2h-34.133V80.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M7.533,267.8v-128c0-13.653,11.947-25.6,25.6-25.6c9.387,0,17.92,5.12,22.187,12.8 c5.973,9.387,12.8,18.773,23.04,24.747l0,0c15.36,9.387,33.28,14.507,51.2,14.507h5.973c11.947,0,23.04-1.707,43.52-7.68l64-26.453 c78.507-23.04,168.96,37.547,174.933,128c0,2.56,0,5.973,0,8.533v162.133H263.533l22.187-87.893 c5.973-25.6-3.413-52.907-25.6-65.707c-8.533-5.12-18.773-8.533-29.867-8.533h-120.32c-28.16,0-51.2,23.04-51.2,51.2v17.067 c0,14.507-11.093,25.6-25.6,25.6s-25.6-11.093-25.6-25.6V267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M33.133,336.067V267.8v-128c0-9.387,5.12-17.92,12.8-22.187c-3.413-1.707-7.68-3.413-12.8-3.413 c-13.653,0-25.6,11.947-25.6,25.6v128v68.267c0,14.507,11.947,25.6,25.6,25.6c4.267,0,9.387-1.707,12.8-3.413 C38.253,353.987,33.133,345.453,33.133,336.067"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2"
    },
    d: "M442.733,259.267c-4.267-76.8-71.68-132.267-145.067-131.413 c60.587,10.24,115.2,61.44,119.467,131.413c0,2.56,0,5.973,0,8.533v162.133h25.6V267.8 C442.733,265.24,442.733,261.827,442.733,259.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00DA6C"
    },
    d: "M374.467,233.667c0,18.773-15.36,34.133-34.133,34.133S306.2,252.44,306.2,233.667 s15.36-34.133,34.133-34.133S374.467,214.893,374.467,233.667"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.267,438.467H252.44l24.747-98.987c5.973-22.187-3.413-45.227-22.187-56.32c-7.68-4.267-17.067-6.827-25.6-6.827 H109.933c-23.893,0-42.667,18.773-42.667,42.667v17.067c0,18.773-15.36,34.133-34.133,34.133S-1,354.84-1,336.067V139.8 c0-18.773,15.36-34.133,34.133-34.133c11.947,0,23.04,6.827,29.867,17.067c5.973,10.24,11.947,17.067,19.627,21.333 c13.653,8.533,29.867,12.8,46.933,12.8h5.973c11.093,0,21.333-1.707,31.573-4.267l89.6-26.453 c45.227-13.653,93.013-5.12,132.267,22.187c36.693,26.453,59.733,66.56,62.293,110.933c0,2.56,0,5.973,0,9.387V438.467z M274.627,421.4H434.2V267.8c0-2.56,0-5.12,0-7.68c-2.56-39.253-22.187-75.093-55.467-98.133 c-34.133-23.893-76.8-31.573-116.907-19.627l-89.6,26.453c-11.947,3.413-23.893,5.12-36.693,5.12h-5.973 c-19.627,0-38.4-5.12-55.467-15.36c-10.24-5.973-17.92-14.507-25.6-27.307c-3.413-5.12-8.533-8.533-14.507-8.533 c-9.387,0-17.067,7.68-17.067,17.067v196.267c0,9.387,7.68,17.067,17.067,17.067s17.067-7.68,17.067-17.067V319 c0-33.28,26.453-59.733,59.733-59.733h119.467c11.947,0,23.893,3.413,34.133,9.387c24.747,14.507,37.547,45.227,29.867,75.093 L274.627,421.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.867,489.667H33.133C14.36,489.667-1,474.307-1,455.533S14.36,421.4,33.133,421.4h443.733 c18.773,0,34.133,15.36,34.133,34.133S495.64,489.667,476.867,489.667z M33.133,438.467c-9.387,0-17.067,7.68-17.067,17.067 s7.68,17.067,17.067,17.067h443.733c9.387,0,17.067-7.68,17.067-17.067s-7.68-17.067-17.067-17.067H33.133z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.133,404.333c-5.12,0-8.533-3.413-8.533-8.533v-34.133c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533V395.8 C41.667,400.92,38.253,404.333,33.133,404.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.2,131.267c-5.12,0-8.533-3.413-8.533-8.533V80.067c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533v42.667 C314.733,127.853,311.32,131.267,306.2,131.267z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348.867,378.733c0,5.12-3.413,8.533-8.533,8.533c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533 C345.453,370.2,348.867,373.613,348.867,378.733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.867,233.667c0,5.12-3.413,8.533-8.533,8.533c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533 C345.453,225.133,348.867,228.547,348.867,233.667"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M383,378.733c0,5.12-3.413,8.533-8.533,8.533c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533 C379.587,370.2,383,373.613,383,378.733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M323.267,88.6h-34.133c-5.12,0-8.533-3.413-8.533-8.533v-51.2c0-5.12,3.413-8.533,8.533-8.533h34.133 c5.12,0,8.533,3.413,8.533,8.533v51.2C331.8,85.187,328.387,88.6,323.267,88.6z M297.667,71.533h17.067V37.4h-17.067V71.533z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M340.333,37.4h-68.267c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h68.267c5.12,0,8.533,3.413,8.533,8.533 S345.453,37.4,340.333,37.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.333,88.6h-68.267c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h68.267 c5.12,0,8.533,3.413,8.533,8.533C348.867,85.187,345.453,88.6,340.333,88.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.333,327.533h-25.6c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h25.6 c5.12,0,8.533,3.413,8.533,8.533C476.867,324.12,473.453,327.533,468.333,327.533z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M485.4,395.8c-14.507,0-25.6-11.093-25.6-25.6V267.8c0-14.507,11.093-25.6,25.6-25.6s25.6,11.093,25.6,25.6v102.4 C511,384.707,499.907,395.8,485.4,395.8z M485.4,259.267c-5.12,0-8.533,3.413-8.533,8.533v102.4c0,5.12,3.413,8.533,8.533,8.533 s8.533-3.413,8.533-8.533V267.8C493.933,262.68,490.52,259.267,485.4,259.267z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.333,276.333c-23.893,0-42.667-18.773-42.667-42.667S316.44,191,340.333,191C364.227,191,383,209.773,383,233.667 S364.227,276.333,340.333,276.333z M340.333,208.067c-14.507,0-25.6,11.093-25.6,25.6c0,14.507,11.093,25.6,25.6,25.6 c14.507,0,25.6-11.093,25.6-25.6C365.933,219.16,354.84,208.067,340.333,208.067z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.667,208.067h-51.2c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h51.2 c5.12,0,8.533,3.413,8.533,8.533C178.2,204.653,174.787,208.067,169.667,208.067z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.8,242.2h-85.333c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533H203.8 c5.12,0,8.533,3.413,8.533,8.533C212.333,238.787,208.92,242.2,203.8,242.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 468.333,
    y: 276.333,
    width: 34.133,
    height: 17.067
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 468.333,
    y: 310.467,
    width: 34.133,
    height: 17.067
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 468.333,
    y: 344.6,
    width: 34.133,
    height: 17.067
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsss);
export default __webpack_public_path__ + "static/media/opsss.5f239bd7737de1699511e2c372629358.svg";
export { ForwardRef as ReactComponent };